import { Box } from '@kluein/klue-ui';
import { useSelector } from 'react-redux';

import { useAuth } from 'contexts/auth';
import TEST_IDS from 'test-ids';

import RivalItem from './RivalItem';

import type { RecentlyViewedType } from 'api/api.types';
import type { StateType } from 'store/models/rivals/rivals.model';
import type { RootState } from 'store/store.types';

type RecentlyViewedProps = {
  currentProfileId?: number;
  onNavigate: VoidFunction;
};

const RecentlyViewed = (props: RecentlyViewedProps) => {
  const { user } = useAuth();
  const recentlyViewed: RecentlyViewedType | undefined =
    user?.userData?.recentlyViewed;

  const rivals = useSelector<RootState, StateType>((state) => state.rivals);
  const rivalsArray = [...rivals.byId];

  const recentlyViewedToDisplay =
    recentlyViewed?.profile
      .filter(({ id }) => rivalsArray.some((item) => item[1].profileId === id))
      .map((profile) => {
        const rival = rivalsArray.find(
          (rival) => rival[1].profileId === profile.id,
        );
        return {
          ...profile,
          rivalId: rival ? rival[1].id : 0,
        };
      }) || [];

  if (recentlyViewedToDisplay.length) {
    return (
      <Box
        gap="xsmall"
        data-test-id={TEST_IDS.layout.quickSwitcher.recentlyViewed}
      >
        {recentlyViewedToDisplay.slice(0, 5).map((item) => (
          <RivalItem
            onNavigate={props.onNavigate}
            key={item.id}
            id={item.rivalId}
            profileId={item.id}
            name={item.name}
            iconUrl={item.logo}
            currentProfileId={props.currentProfileId}
            profileButtonTestId={
              TEST_IDS.layout.quickSwitcher.recentlyViewedProfileButton
            }
            battlecardButtonTestId={
              TEST_IDS.layout.quickSwitcher.recentlyViewedBattlecardButton
            }
          />
        ))}
      </Box>
    );
  }

  return null;
};

export default RecentlyViewed;
